import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=7b7fd655&scoped=true&"
import script from "./VideoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=7b7fd655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7fd655",
  null
  
)

export default component.exports